<h1 mat-dialog-title>Resetar senha de {{ data.user.firstName }}</h1>

<form [formGroup]="form" (ngSubmit)="onConfirm()">
  <div mat-dialog-content fxLayout="column" fxLayoutGap="0.5rem">
    <mat-checkbox formControlName="generatePassword" color="primary">
      Gerar senha automaticamente
    </mat-checkbox>

    <mat-form-field appearance="standard">
      <mat-label>Nova senha</mat-label>
      <input
        matInput
        type="password"
        formControlName="newPassword"
        autocomplete="new-password"
        [readonly]="form.get('generatePassword')?.value"
      />
      <mat-error *ngIf="form.get('newPassword')?.hasError('required')">
        Informe a nova senha.
      </mat-error>
      <mat-error *ngIf="form.get('newPassword')?.hasError('minlength')">
        A senha deve ter no mínimo 6 caracteres.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label>Confirmar senha</mat-label>
      <input
        matInput
        type="password"
        formControlName="confirmPassword"
        autocomplete="new-password"
        [readonly]="form.get('generatePassword')?.value"
      />
      <mat-error *ngIf="form.get('confirmPassword')?.hasError('required')">
        Confirme a nova senha.
      </mat-error>
    </mat-form-field>

    <mat-error *ngIf="passwordMismatch" class="match-error">
      As senhas não conferem.
    </mat-error>

    <mat-checkbox formControlName="requireChangePassword" color="primary">
      Exigir troca no próximo acesso
    </mat-checkbox>
  </div>

  <div mat-dialog-actions align="end" fxLayoutGap="0.5rem">
    <button mat-button type="button" (click)="onCancel()">Cancelar</button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="form.invalid"
    >
      Confirmar
    </button>
  </div>
</form>
